module.exports = __webpack_public_path__ + "Roboto-Bold.e31fcf1885e371e19f57.ttf";


//////////////////
// WEBPACK FOOTER
// /var/www/html/prod/resources/assets/frontend/src/assets/font/roboto/Roboto-Bold.ttf
// module id = ../../../../../src/assets/font/roboto/Roboto-Bold.ttf
// module chunks = 29